const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });

  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const message = data?.error || `Error de red (${res.status})`;
    throw new Error(message);
  }
  return data;
}

// El backend (MySQL/Sequelize) ya expone "id" directamente; se mantiene esta normalización
// por si en algún momento se listan datos de otro origen con forma distinta.
function normalizeProvider(provider) {
  if (!provider) return provider;
  return { ...provider, id: provider.id };
}

export async function fetchProviders(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  const data = await request(`/providers?${query.toString()}`);
  return { ...data, providers: (data.providers || []).map(normalizeProvider) };
}

export async function fetchProviderById(id) {
  const data = await request(`/providers/${id}`);
  return normalizeProvider(data.provider);
}

export async function registerProvider(payload) {
  const data = await request('/providers', { method: 'POST', body: JSON.stringify(payload) });
  return { ...data, provider: normalizeProvider(data.provider) };
}

export async function submitQuote(payload) {
  return request('/quotes', { method: 'POST', body: JSON.stringify(payload) });
}
